import api from "@/services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ListParams } from "../types/common";
import { SaveTestimonialPayload } from "../types/testimonialType";

export const getTestimonialList = createAsyncThunk("/testimonial/list", async (params: ListParams = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.keyword) query.set("keyword", params.keyword);
  const response = (await api.get(`/testimonial?${query.toString()}`)).data;
  return response;
});

export const saveTestimonial = createAsyncThunk("/testimonial/save", async (payload: SaveTestimonialPayload) => {
  const response = (await api.post("/testimonial/action", payload)).data;
  return response;
});

export const deleteTestimonial = createAsyncThunk("/testimonial/delete", async (id: number) => {
  const response = (await api.get(`/testimonial/delete/${id}`)).data;
  return response;
});
